// import {post} from '@/util/utils';
import axios from 'axios';
// function fetchLayoutData(id) {
// 	return get('index.php?s=/designer/info.html&id=' + id);
// }




function fetchLayoutData(id) {
	var data={
		"appKey": "6c912613d53e6ce0",
		"sign": "M2Y4ZDlhM2ZkODE4MGVjNTU2YzAzMGM2MTY2NmFmNjdmNGY0OWU2ZmE2OWNmYTFkODFiMDkyZDM0MTdlNzczNQ==",
		"worksheetId": 'dashboard',
		"rowId": id,
		"getSystemControl":false,
	}
	var headers = {
		'Content-Type': 'application/json'
	}
	var response=axios.post('/api/v2/open/worksheet/getRowByIdPost',data,{headers})

	return response;
}

function saveLayoutData(id, title, raw) {
	var data={
		"appKey": "6c912613d53e6ce0",
		"sign": "M2Y4ZDlhM2ZkODE4MGVjNTU2YzAzMGM2MTY2NmFmNjdmNGY0OWU2ZmE2OWNmYTFkODFiMDkyZDM0MTdlNzczNQ==",
		"worksheetId": 'dashboard',
		"rowId": id,
		"getSystemControl":false,
		"controls":[
			{
			"controlId":"workshop",
			"value":title
			},{
				"controlId":"raw",
				"value":raw
				}]
	}
	var headers = {
		'Content-Type': 'application/json'
	}
	return axios.post('/api/v2/open/worksheet/editRow',data,{headers});
}

export {fetchLayoutData, saveLayoutData};
